/* @flow */

import React from 'react';
import { Modal, Grid, Button, Header, Message } from 'semantic-ui-react';
import VirtualizedSelect from 'react-virtualized-select';

type Props = {
  visible: boolean,
  pages: List<CatalogPage>,
  onSelected: (page: CatalogPage) => void,
  onSwitchMode: () => void,
  onClose: () => void,
};

const pagesToOptions = pages =>
  pages
    .filter(p => !p.template.isLocked)
    .map(p => ({
      label: p.name,
      value: p.id,
    }))
    .toArray();

const SelectPageModal = ({
  visible,
  pages,
  onClose,
  onSwitchMode,
  onSelected,
}: Props) => {
  const options = pagesToOptions(pages);

  const selectPage = ({ value }) => onSelected(pages.find(p => p.id === value));

  return (
    <Modal open={visible} onClose={onClose} closeIcon>
      <Modal.Header>
        <Grid columns={2}>
          <Grid.Column><Header>Sélection de page</Header></Grid.Column>
          <Grid.Column>
            <Button
              onClick={onSwitchMode}
              floated="right"
              primary
              labelPosition="left"
              icon="add"
              content="Créer une page"
            />
          </Grid.Column>
        </Grid>
      </Modal.Header>
      <Modal.Content>
        {options.length > 0 &&
          <VirtualizedSelect
            options={options}
            placeholder="Sélectionnez une page"
            noResultsText="Aucune page ne correspond aux critères de recherche"
            onChange={selectPage}
          />}
        {options.length === 0 &&
          <Message
            icon="info"
            content="Aucune page disponible. Veuillez en créer au moins une"
          />}
      </Modal.Content>
    </Modal>
  );
};

export default SelectPageModal;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/shared/components/SelectPageModal.js